<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/property-definition' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.ViewProperty") }}</h4>
              </router-link>
            </li>
          </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletePropertyPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table v-if="propertyViewData" class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("setup.label.PropertyCode") }}</b>
                </td>
                <td>{{ propertyViewData.propertyCode }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.PropertyType") }}</b>
                </td>
                <td>{{ propertyViewData.propertyType }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Parcel") }}</b>
                </td>
                <td>{{ propertyViewData.parcel }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Precinct") }}</b>
                </td>
                <td>{{ propertyViewData.precinct }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.BuildingCode") }}</b>
                </td>
                <td>{{ propertyViewData.buildingCode }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletePropertyPopup"
      :title="$t('setup.label.Property')"
      @deletePressed="deleteProperty()"
      @cancelPressed="deletePropertyPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      deletePropertyPopup: false,
    };
  },

  computed: {
    ...mapState({
      propertyViewData: (state) => state.propertyDefinition.propertyView,
    }),
  },
  methods: {
    async getPropertyViewData() {
      try {
        await this.$store.dispatch(
          "propertyDefinition/viewPropertyAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteProperty() {
      try {
        this.deletePropertyPopup = false;
        await this.$store.dispatch(
          "propertyDefinition/deletePropertyAction",
          this.id
        );
        this.$router.push({ path: `/setup/property-definition` });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData() {
      this.$router.push({
        path: `/setup/property-definition/EditProperty/${this.id}`,
      });
    },
  },
  filters: {},
  created() {
    this.id = this.$route.params.id;
    this.getPropertyViewData();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
